module.exports = __webpack_public_path__ + "static/Aplicaciones-paginas-web-marketing-FeedYourWeb-logo-footer-96a62faa02fabb6eadeb50a92fae6d7e.svg";